module.exports = __webpack_public_path__ + "img/ico-youtube-circle.fcbe244c.svg";